// extracted by mini-css-extract-plugin
export default {"MainContainer":"Main_MainContainer__T7iHM","text":"Main_text__9DOTn","education":"Main_education__JAyFY","photo":"Main_photo__KtJkt"};